import React from 'react';
import styled from 'styled-components';
import {
  minBreakpointQuery,
  breakpointSizes,
  fluidFontSize,
} from '../../styles';
import { Heading } from '.';

const StyledSectionHeader = styled.header`
  margin: 0 auto 30px;
  max-width: 1100px;
  text-align: center;

  ${minBreakpointQuery.small`
    margin-bottom: 40px;
  `}

  ${minBreakpointQuery.large`
    margin-bottom: 50px;
  `}
`;

const StyledText = styled.p`
  margin-top: 10px;
  ${fluidFontSize(
    '18px',
    '33px',
    breakpointSizes.tiny,
    breakpointSizes.xxxxlarge,
  )};
`;

export const SectionHeader = ({ heading, text }) => (
  <StyledSectionHeader>
    <Heading>{heading}</Heading>
    {text && <StyledText>{text}</StyledText>}
  </StyledSectionHeader>
);
